const isScrollable = (wrapperHeight, contentHeight) => contentHeight > wrapperHeight;

export default isScrollable;
